<template>
  <div class="portfolio">
    <div class="wrapper">
      <h1>Портфолио</h1>

      <div class="portfolio__text">
        Небольшое количество примеров выполненной мной верстки.
      </div>

      <div class="portfolio-wrapper" v-if="portfolioArray && portfolioArray.length">
        <div class="portfolio-block" v-for="(key, i) in portfolioArray" :key="i">

          <div class="portfolio-block__pic">
            <img v-for="(img,q) in key.img_src" :src="'/images/portfolio/' + img" :key="q">
          </div>

          <div class="portfolio-block__desc">
            <a :href="key.href_html" target="_blank" rel="nofollow" v-if="key.href_html">Ссылка на html</a>
            <a :href="key.href_site" target="_blank" rel="nofollow" v-if="key.href_site">Ссылка на сайт</a>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Portfolio",
  data () {
    return {
      portfolioArray: [],
    }
  },
  methods: {
    listPortfolioCreate() {
      this.portfolioArray = [
        {
          name: 'Сайт korablik.ru',
          href_html: '',
          href_site: 'https://www.korablik.ru/',
          img_src: ['korablik-1.jpg', 'korablik-2.jpg', 'korablik-3.jpg'],
        },
        {
          name: 'Предзаказ на HUAWEI MateBook 16',
          href_html: '/porfolio_files/mvideo_huawei-matebook-16/index.html',
          href_site: 'https://www.mvideo.ru/promo/noutbuk-huawei-matebook16',
          img_src: ['mhm16-1.jpg', 'mhm16-2.jpg', 'mhm16-3.jpg'],
        },
        {
          name: 'Фандоматы в М.Видео',
          href_html: '/porfolio_files/fandomaty-v-mvideo/index.html',
          href_site: 'https://www.mvideo.ru/promo/fandomaty-v-mvideo',
          img_src: ['fvm-1.jpg', 'fvm-2.jpg'],
        },
        {
          name: 'Фены и электрощипцы BaByliss',
          href_html: '/porfolio_files/babyliss/index.html',
          href_site: 'https://www.mvideo.ru/promo/elektroshiptci-i-feni-ot-babyliss',
          img_src: ['babyliss-1.jpg', 'babyliss-2.jpg'],
        },
        {
          name: 'Виртуальные подарочные карты',
          href_html: '/porfolio_files/best2pay/index.html',
          href_site: 'https://www.mvideo.ru/promotion/virtualnye-podarochnie-karty',
          img_src: ['best2pay-1.jpg', 'best2pay-2.jpg'],
        },
        {
          name: 'Суперскидки на любимые блендеры Braun',
          href_html: '/porfolio_files/blendery-braun/index.html',
          href_site: 'https://www.mvideo.ru/promo/superskidki-na-blendery-braun',
          img_src: ['blendery-braun-1.jpg', 'blendery-braun-2.jpg', 'blendery-braun-3.jpg'],
        },
        {
          name: 'FORMULA 1 от Rowenta',
          href_html: '/porfolio_files/formula1/index.html',
          href_site: 'https://www.mvideo.ru/promo/tehnika-ot-rowenta-kollekcii-formula1',
          img_src: ['formula1-1.jpg', 'formula1-2.jpg', 'formula1-3.jpg'],
        },
        {
          name: 'Новый Galaxy Z Flip3 5G',
          href_html: '/porfolio_files/galaxy-z-flip3-5g/index.html',
          href_site: '',
          img_src: ['z-flip3-1.jpg', 'z-flip3-2.jpg', 'z-flip3-3.jpg'],
        },
        {
          name: 'HONOR MagicBook 16',
          href_html: '/porfolio_files/honor-magicbook-16/index.html',
          href_site: 'https://www.mvideo.ru/promo/noutbuk-honor-magicbook-16',
          img_src: ['magicbook-16-1.jpg', 'magicbook-16-2.jpg', 'magicbook-16-3.jpg'],
        },
        {
          name: 'HUAWEI MateBook E',
          href_html: '/porfolio_files/matebook-e/index.html',
          href_site: 'https://www.mvideo.ru/promo/noutbuk-transformer-huawei-matebook-e',
          img_src: ['matebook-e-1.jpg', 'matebook-e-2.jpg', 'matebook-e-3.jpg'],
        },
        {
          name: 'ТВ Novex',
          href_html: '/porfolio_files/novex/index.html',
          href_site: 'https://www.mvideo.ru/promo/televizory-novex',
          img_src: ['novex-1.jpg', 'novex-2.jpg', 'novex-3.jpg'],
        },
        {
          name: 'История Hisense',
          href_html: '/porfolio_files/hisense-hystory/index.html',
          href_site: '',
          img_src: ['hisense-hystory-1.jpg', 'hisense-hystory-2.jpg', 'hisense-hystory-3.jpg'],
        },
        {
          name: 'Портативный проектор The Freestyle',
          href_html: '/porfolio_files/samsung_freestyle/index.html',
          href_site: 'https://www.mvideo.ru/promo/samsung-the-freestyle',
          img_src: ['freestyle-1.jpg', 'freestyle-2.jpg', 'freestyle-3.jpg'],
        },
      ]
    }
  },
  mounted () {
    this.listPortfolioCreate()
  }
}
</script>

<style lang="scss" scoped>
.portfolio {
  &__text {
    padding: 10px 0 25px;
    font: 14px/1.5 Tahoma, sans-serif;

    @media screen and (min-width: 768px){
      font: 15px/1.2 Tahoma, sans-serif;
    }
  }
}

.portfolio-wrapper {
  display: flex;
  gap: 30px 4%;
  flex-wrap: wrap;

  @media screen and (min-width: 768px){
    gap: 50px 5%;
  }
}

.portfolio-block {
  flex: 0 1 48%;
  position: relative;

  @media screen and (min-width: 768px){
    flex: 0 1 30%;
    border: 1px solid #082e76;
    padding: 10px;
  }

  &:nth-child(2n+1) {
    flex-direction: row-reverse;
  }

  &__desc {
    margin-top: 20px;
    text-align: center;

    a {
      display: block;
      font: 14px/1.2 Tahoma, sans-serif;
      text-decoration: none;

      @media screen and (min-width: 1024px){
        display: inline-block;
      }

      &:hover {
        text-decoration: underline;
      }
    }

    a + a {
      margin: 5px 0 0 0;

      @media screen and (min-width: 1024px){
        margin: 0 0 0 20px;
      }
    }
  }

  &__pic {
    position: relative;

    &:before {
      display: none;

      @media screen and (min-width: 768px){
        content: '';
        display: block;
        width: 100%;
        position: relative;
        aspect-ratio: 1 / 1;
      }
    }

    img {
      display: block;
      position: relative;
      width: 100%;
      height: auto;
      border: 1px solid #aaaaaa;
      vertical-align: bottom;

      @media screen and (min-width: 768px){
        position: absolute;
        width: 45%;
        height: auto;
        transition: .3s all linear;
      }

      &:nth-child(n + 2) {
        display: none;

        @media screen and (min-width: 768px){
          display: block;
        }
      }

      &:nth-child(1) {
        z-index: 2;

        @media screen and (min-width: 768px){
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }

      &:nth-child(2) {
        display: none;

        @media screen and (min-width: 768px){
          display: block;
          top: 0;
          left: 0;
        }
      }

      &:nth-child(3) {
        bottom: 0;
        right: 0;
      }

      &:hover {
        z-index: 5;
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>